import { graphql } from '../../../graphql/generated';

export const UPDATE_REQUEST_COMMENT_MUTATION = graphql(`
  mutation UpdateRequestComment($requestId: ID!, $comment: String!) {
    updateRequestComment(requestId: $requestId, comment: $comment) {
      id
    }
  }
`);
